import React from "react";
import { Box, Heading, Flex, Image, Text } from "@chakra-ui/react";

import about from "../../assets/images/about.png";
import yellow from "../../assets/images/yellowstar.png";
import Animated from "./AnimatedSection";
const AboutSection = () => {
  return (
    <>
      <Animated>
        <Box mt={{ base: 10, lg: 12 }} id="about">
          <Box w="90%" m="auto ">
            <Heading
              color="white"
              lineHeight={{ base: "28px", lg: "40px" }}
              // fontWeight={"200"}
              fontSize={{ base: "20px", lg: "26px" }}
              textAlign={"center"}
            >
              THE INTERNATIONAL IDEATORS CUP IS MORE THAN JUST A CHALLENGE; IT'S
              AN OPPORTUNITY TO UNLEASH YOUR CREATIVE GENIUS AND CONNECT WITH
              LIKE-MINDED STORYTELLERS FROM AROUND THE WORLD. THROUGH IMMERSIVE
              ROUNDS IN CREATIVE WRITING, STORYTELLING, AND FILMMAKING,
              PARTICIPANTS WILL SHARPEN THEIR SKILLS AND MAKE THEIR MARK ON A
              GLOBAL STAGE.
            </Heading>
          </Box>
        </Box>

        <Box py={{ base: 0, lg: 8 }}>
          <Flex
            gap={{ base: 6, xl: 8 }}
            borderRadius="24px"
            alignItems="center"
            m="auto"
            w="90%"
            flexDirection={{ base: "column", xl: "row" }}
            position="relative"
          >
            {/* Left Image */}
            <Box mt={6} w={{ base: "100%", xl: "50%" }}>
              <Image w="100%" h="100%" objectFit="cover" src={about} />
            </Box>

            <Box
              mt={{ base: 0, xl: 12 }}
              w={{ base: "100%", xl: "50%" }}
              bgGradient="linear(to-b, brand.100, rgba(120, 40, 200, 1))"
              borderRadius="24px"
              p={6}
              color="white"
            >
              <Box>
                <Heading fontSize={{ base: "26px", lg: "54px" }}>
                  INTERNATIONAL EXPOSURE
                </Heading>
              </Box>

              <Animated>
                <Flex mt={4} direction="column" rowGap={{ base: 4, lg: 6 }}>
                  {[
                    {
                      title: "Multi-Round Format",
                      description:
                        "Progress from regional to global challenges.",
                    },
                    {
                      title: "Industry Recognition",
                      description:
                        "Be judged by top professionals in media, storytelling, and filmmaking.",
                    },
                    {
                      title: "Bridging Cultures Through Creativity",
                      description:
                        "Work alongside peers from different backgrounds.",
                    },
                    {
                      title: "Unmatched Rewards",
                      description:
                        "Win the grand *$50,000 University Scholarship* and many more prizes.",
                    },
                  ].map((item, index) => (
                    <Flex key={index} alignItems="start" gap={2}>
                      <Image
                        mt={{ base: "6px", lg: 1 }}
                        w="18px"
                        h="18px"
                        src={yellow}
                      />
                      <Text w="90%" fontSize={{ base: "16px", lg: "18px" }}>
                        <Text as="b">{item.title}</Text> – {item.description}
                      </Text>
                    </Flex>
                  ))}
                </Flex>
              </Animated>
            </Box>
          </Flex>
        </Box>
      </Animated>
    </>
  );
};

export default AboutSection;
